import React from 'react';
import {useParams} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import {Container} from '@material-ui/core';
import {useDispatch} from 'react-redux';
import Layout from '../components/Layout';
import {prepareInitialCategoryBlogsState} from '../redux/slices/category-blog';
import CategoryBlogsContainer from '../components/CategoryBlogs/CategoryBlogsContainer';

/**
 * A page that'll show the blog posts by a category
 */
function CategoryBlogs() {
  const {category} = useParams();
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(prepareInitialCategoryBlogsState(category));
  }, [category, dispatch]);

  return (
    <Layout>
      <Helmet>
        <title>{category} Blogs | Khaaba</title>
      </Helmet>
      <Container maxWidth="md">
        <CategoryBlogsContainer category={category} />
      </Container>
    </Layout>
  );
}

export default CategoryBlogs;
